"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6140],{

/***/ 56140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_Faq; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/Faq/faq.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 7.5rem 0;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 4rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e2droop0"
})("padding:4rem 0;", mixins.mq.mobileMax((0,emotion_react_browser_esm/* css */.iv)(_templateObject())));
const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2droop1"
})(mixins/* defaultContainerSize */.sX, ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "e2droop2"
})(Typography/* Header2 */.zV, ";color:", theme/* THEME.colors.black */.C.colors.black, ";margin:0;");
const ItemsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2droop3"
})("margin-top:2rem;", mixins.mq.mobileMax((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())));
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e2droop4"
})(Typography/* ParagraphM */.Sl, ";color:", theme/* THEME.colors.dark_grey */.C.colors.dark_grey, ";margin:0;padding:0 0 2rem 0;");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
;// CONCATENATED MODULE: ./components/sections/Faq/faq.hooks.ts


const useFaq = ()=>{
    const [expandedItem, setExpandedItem] = (0,react.useState)("");
    const { medium  } = (0,useWindowSize/* useWindowSize */.i)();
    const answersRef = (0,react.useRef)([]);
    const answerRef = (0,react.useRef)();
    const handleExpand = (0,react.useCallback)((evt, faqId)=>{
        if (expandedItem !== faqId) {
            setExpandedItem(faqId);
            if (!medium) {
                scrollToExpanded(evt);
            }
        } else {
            setExpandedItem("");
        }
    }, [
        expandedItem,
        medium
    ]);
    const scrollToExpanded = (evt)=>{
        let position = 0;
        if (answerRef.current && answerRef.current.offsetTop < evt.target.offsetTop) {
            var _answerRef_current_parentElement;
            position = evt.target.parentElement.offsetTop - (((_answerRef_current_parentElement = answerRef.current.parentElement) === null || _answerRef_current_parentElement === void 0 ? void 0 : _answerRef_current_parentElement.offsetHeight) || 0);
        } else {
            position = evt.target.parentElement.offsetTop - evt.target.parentElement.offsetHeight;
        }
        if (position > 0) {
            window.scrollTo({
                top: position,
                behavior: "smooth"
            });
        }
        answerRef.current = evt.target;
    };
    return {
        expandedItem,
        handleExpand,
        answerRef,
        answersRef
    };
};

// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
;// CONCATENATED MODULE: ./components/sections/Faq/FaqItem/faqItem.styles.ts

function faqItem_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 4.375rem 0 3.438rem;\n  "
    ]);
    faqItem_styles_templateObject = function() {
        return data;
    };
    return data;
}
function faqItem_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        svg {\n          transform: rotate(180deg);\n\n          path {\n            stroke: ",
        ";\n          }\n        }\n      }\n    "
    ]);
    faqItem_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.5rem;\n    line-height: 2.25rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n    "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}





const faqItem_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ei3s4hq0"
})("border-bottom:0.0625rem solid ", theme/* THEME.colors.grey */.C.colors.grey, ";padding:1rem 0;", mixins.mq.mobileMax((0,emotion_react_browser_esm/* css */.iv)(faqItem_styles_templateObject())), " ", (param)=>{
    let { expanded  } = param;
    return expanded && (0,emotion_react_browser_esm/* css */.iv)(faqItem_styles_templateObject1(), Question, theme/* THEME.colors.accent */.C.colors.accent);
});
const Question = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "ei3s4hq1"
})(Typography/* ParagraphM */.Sl, ";color:", theme/* THEME.colors.core_black */.C.colors.core_black, ";line-height:1.875rem;margin:0;padding:1.25rem 4rem 1.25rem 0;position:relative;cursor:pointer;display:block;user-select:none;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), "  &:after{content:'';height:2.875rem;width:2.875rem;position:absolute;border:0.0625rem solid ", theme/* THEME.colors.core_white */.C.colors.core_white, ";border-radius:3rem;top:calc(50% - 1.5rem);right:0;box-shadow:0.5rem 0.5rem 1.5rem rgba(23,0,89,0.29);opacity:0;transition:opacity 300ms ease-in-out;}&:hover{&:after{opacity:1;}.svg{border-color:", theme/* THEME.colors.core_white */.C.colors.core_white, ";}}svg{width:1rem;height:1rem;border-radius:3rem;position:absolute;border:0.0625rem solid ", theme/* THEME.colors.grey */.C.colors.grey, ";top:calc(50% - 1.5rem);right:0;transition:transform 300ms ease-in-out,border-color 300ms ease-in-out;padding:0.9375rem;path{stroke:", theme/* THEME.colors.primary */.C.colors.primary, ";transition:stroke 300ms ease-in-out;}}");
const Answer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ei3s4hq2"
})("max-height:0;transition:max-height 300ms ease-in-out,opacity 300ms ease-in-out;overflow:hidden;opacity:0;", (param)=>{
    let { expanded  } = param;
    return expanded && (0,emotion_react_browser_esm/* css */.iv)(_templateObject3());
});

;// CONCATENATED MODULE: ./utils/htmlSerializers/faqHtmlSerializer.tsx




const linkResolver = ()=>"/";
const propsWithUniqueKey = (props, key)=>Object.assign(props || {}, {
        key
    });
// TODO: type of this function
const faqHtmlSerializer = (type, element, content, children, key)=>{
    let props = {};
    switch(type){
        case prismic_reactjs.Elements.paragraph:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                ...propsWithUniqueKey(props, key),
                children: children
            });
        case prismic_reactjs.Elements.hyperlink:
            const targetAttr = element.data.target ? {
                target: element.data.target
            } : {};
            const relAttr = element.data.target ? {
                rel: "noreferrer noopener"
            } : {};
            const href = element.data.link_type === "Web" && element.data.url.includes("https://qodeca.com/") ? new URL(element.data.url).pathname : element.data.url || linkResolver(element.data);
            props = Object.assign({
                href,
                className: "faq__link"
            }, targetAttr, relAttr);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                ...propsWithUniqueKey(props, key),
                children: children
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./components/sections/Faq/FaqItem/FaqItem.tsx
// @flow





const FaqItem = (param)=>{
    let { expanded , handleClick , faqItem , faqId , id , answersRefs  } = param;
    var _answersRefs_current;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(faqItem_styles_Wrapper, {
        expanded: expanded,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Question, {
                onClick: (evt)=>handleClick(evt, faqId),
                children: [
                    prismic_reactjs.RichText.asText(faqItem.question),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                        width: "19",
                        height: "11",
                        viewBox: "0 0 19 11",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M1 1L9.5 9.5L18 1"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Answer, {
                style: {
                    maxHeight: expanded ? "".concat((_answersRefs_current = answersRefs.current) === null || _answersRefs_current === void 0 ? void 0 : _answersRefs_current[id].scrollHeight, "px") : "0"
                },
                expanded: expanded,
                ref: (ref)=>answersRefs.current[id] = ref,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(prismic_reactjs.RichText, {
                    render: faqItem.answer,
                    htmlSerializer: faqHtmlSerializer
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/Faq/Faq.tsx




const getFaqId = (index)=>"faq-".concat(index);
const Faq = (param)=>{
    let { title , items , id , titleAs  } = param;
    const { answersRef , answerRef , handleExpand , expandedItem  } = useFaq();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        id: id && id,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    as: titleAs,
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemsWrapper, {
                    children: items.map((faqItem, i)=>{
                        const faqId = getFaqId(i);
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqItem, {
                            answersRefs: answersRef,
                            expanded: expandedItem === faqId,
                            faqId: faqId,
                            id: i,
                            handleClick: handleExpand,
                            faqItem: faqItem
                        }, faqId);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/Faq/index.ts

/* harmony default export */ var sections_Faq = (Faq);


/***/ })

}]);